<template>
<div class="permissions-index">
  <div class="col-md-12 card">
    <div class="card-content row">
      <div class="col-sm-6 col-md-9">
      </div>
      <div class="col-sm-6 col-md-3">
        <p-search @on-search="handleSearch($event)"></p-search>
      </div>
      <div class="col-sm-12">
        <el-table
          class="table-striped"
          :data="roles"
          :default-sort="{prop: 'createdAt', order: 'descending'}"
          @sort-change="handleSort($event)"
          v-loading="loading"
          style="width: 100%"
        >

          <el-table-column
            prop="label"
            label="Perfil"
            sortable
            :min-width="200"
          ></el-table-column>
          <el-table-column
            :min-width="120"
            fixed="right"
            label=""
          >
            <template slot-scope="props">
            <div class="text-right">
              <router-link :to="{name: 'roles.edit', params: {id: props.row._id}}">
                <a
                  v-if="$can('roles.edit')"
                  class="btn btn-primary btn-fill btn-icon edit"
                  title="Editar permissão"
                ><i class="ti-pencil-alt"></i></a>
              </router-link>
              <a
                class="btn btn-danger btn-fill btn-icon remove"
                title="Remover permissão"
                v-if="canBeDeleted(props.row.name) && $can('roles.remove')"
                @click="handleDelete(props.$index, props.row)"
              ><i class="ti-trash"></i></a>
            </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="col-sm-12 text-center">
        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        ></p-pagination>
      </div>
    </div>
  </div>

  <div class="col-sm-12 pagination-info text-right">
    <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
  </div>

</div>
</template>

<script>
import { Option, Select, Table, TableColumn } from 'element-ui'
import PSearch from 'src/components/UIComponents/Inputs/Search.vue'
import PPagination from 'src/components/UIComponents/Pagination.vue'
import swal from 'sweetalert2'
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
export default {
  name: 'permissions-index',
  components: {
    PPagination, PSearch
  },
  data () {
    return {
      pagination: {
        perPage: 1000,
        currentPage: 1,
        total: 0
      },
      sort: {
        field: 'createdAt',
        direction: 'desc'
      },
      search: {
        query: '',
        fields: ['name', 'label']
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    ...mapGetters('roles', {
      loading: 'loading',
      roles: 'roles',
      role: 'role'
    }),
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      this.pagination.total = this.count
      return this.count
    },
    currentPage () {
      return this.pagination.currentPage
    }
  },
  methods: {
    ...mapActions('roles', ['fetchAll', 'fetchOne', 'delete']),
    fetch () {
      this.fetchAll({
        'limit': this.pagination.perPage,
        'skip': this.from,
        'sort': this.sort,
        'search': this.search
      })
    },
    handleSearch (query) {
      this.search.query = query
      this.fetch()
    },
    handleSort (sort) {
      this.sort = { field: sort.prop, direction: sort.order }
      this.fetch()
    },
    handleDelete (index, row) {
      swal({
        title: 'Você tem certeza?',
        text: `Não será possível reverter essa ação!`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(() => {
        this.delete(row._id).then(result => {
          this.$notify({
            message: 'Registro deletado com sucesso.',
            type: 'success'
          })
          this.fetchAll()
        }).catch(err => console.log(err))
      })
    },
    canBeDeleted (name) { // Essas permissões são as padrões no sistemas não podem ser deletadas
      return ['atendente', 'administrador', 'supervisor'].indexOf(name) < 0 || this.user.role === 'superadmin'
    }
  },

  mounted () {
    this.fetch()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Roles/RolesIndex.vue